module.exports = __webpack_public_path__ + "img/loadmoney.1367404a.svg";